import { render } from "./AppBaseSelect.vue?vue&type=template&id=563f4afb"
import script from "./AppBaseSelect.vue?vue&type=script&lang=js"
export * from "./AppBaseSelect.vue?vue&type=script&lang=js"

import "./AppBaseSelect.vue?vue&type=style&index=0&id=563f4afb&lang=scss"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__